<script setup lang="ts">

import { FilterDateRange, FiltersBar } from '@shared/ui/filters'
import { AppMultiSelect, AppSelect } from '@shared/ui/selects'

import LessonsControls from './LessonsControls.vue'
import LessonFilterTutors from './LessonFilterTutors.vue'
import { useFiltersLessons } from '../../model/lessons/filters-lessons.hook'

defineOptions({
  name: 'FiltersLessons',
})

const {
  refDateRange,
  refTutorIds,
  refStatuses,
  refTypes,
  refSortDirection,
  refDayOfWeek,
  statusOptions,
  typeOptions,
  sortOptions,
  dayOptions,
  isLoading,
  clearFilters,
  submitSearch,
} = useFiltersLessons()
</script>

<template>
  <FiltersBar
    class="filters-lessons"
    :loading="isLoading"
    @click:submit="submitSearch"
    @click:clear="clearFilters"
  >
    <template #fields>
      <FilterDateRange
        v-model="refDateRange"
        presets
        class="filters-lessons__date"
        label="Date"
        placeholder="Search"
        :partial-range="false"
        :disabled="isLoading"
      />

      <AppMultiSelect
        v-model="refStatuses"
        class="filters-lessons__select"
        :options="statusOptions"
        label="Status"
        placeholder="All"
        :panel-min-width="200"
        :disabled="isLoading"
        clearable
      />

      <AppMultiSelect
        v-model="refTypes"
        class="filters-lessons__select"
        :options="typeOptions"
        label="Type"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />

      <LessonFilterTutors
        v-model="refTutorIds"
        class="filters-lessons__tutors"
        :disabled="isLoading"
      />

      <AppSelect
        v-model="refSortDirection"
        class="filters-lessons__sort"
        :options="sortOptions"
        label="Sort by date"
        :disabled="isLoading"
      />

      <AppSelect
        v-model="refDayOfWeek"
        class="filters-lessons__day"
        :options="dayOptions"
        label="Day of week"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />
    </template>

    <template #end>
      <LessonsControls :disabled="isLoading" />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersLessons.scss" />
